"use client"

import Li from "./Li"
import Ul from "./Ul"

export default {
  Li,
  Ul
}
